/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb75Inputs */

const en__field_enum_pbs_fb75 = /** @type {(inputs: _Field_Enum_Pbs_Fb75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 07 Faculty of Catholic Theology`)
};

const de__field_enum_pbs_fb75 = /** @type {(inputs: _Field_Enum_Pbs_Fb75Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 07 Katholische Theologie`)
};

/**
* | output |
* | --- |
* | "F 07 Faculty of Catholic Theology" |
*
* @param {_Field_Enum_Pbs_Fb75Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb75 = /** @type {((inputs?: _Field_Enum_Pbs_Fb75Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb75Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb75(inputs)
	return de__field_enum_pbs_fb75(inputs)
});
export { _field_enum_pbs_fb75 as "_field_enum_PBS_FB7" }